import resource from "@core/Util/resources";

import Index from './Components/Index.vue';
import Templates from './Components/Templates.vue';
import Overview from './Components/Overview.vue';

import DefaultLayout from "@core/Components/Layout/DefaultLayout.vue";
import {RouteNames} from "./constants";

const routes = [{
    path: '/DmVisualizer/',
    component: DefaultLayout,
    
    children: [{
        name: RouteNames.INDEX,
        
        path: '',
        component: Index,
        props: route => ({ divisionId: route.query && route.query.divisionId }),
        meta: {
            title: resource('DmVisualizer_Index_Title'),
            header: resource('DmVisualizer_Index_ContentHeader'),
            breadcrumb: resource('Breadcrumb_DmVisualizer')
        }
    }, {
        name: RouteNames.TEMPLATES,
        
        path: 'templates',
        component: Templates,
        props: route => {
            const query = route.query;
            
            return {
                divisionId: query.divisionId,
                
                //Singular parameters are provided as regular strings - ensure our scenarioIds prop is passed as an array
                //We may assume we always have at least a single scenarioId
                scenarioIds: Array.isArray(query.scenarioIds) ? query.scenarioIds : [query.scenarioIds]
            }
        },
        meta: {
            title: resource('DmVisualizer_Templates_Title'),
            header: resource('DmVisualizer_Templates_Heading'),
            breadcrumb: resource('BreadCrumb_DmVisualizer_Templates')
        }
    }, {
        name: RouteNames.OVERVIEW,
        
        path: 'overview',
        component: Overview,
        props: route => ({ divisionId: route.query && route.query.divisionId }),
        meta: {
            title: resource('DmVisualizer_Overview_Title'),
            header: resource('DmVisualizer_Overview_ContentHeader'),
            breadcrumb: resource('Breadcrumb_DmVisualizer')
        }
    }]
}];

export {
    routes
};